const GlobalNotificationBar = () => {
  const showGlobalBar = localStorage.getItem('showGlobalBar');
  const $notificationBar = $('.notification-bar--global');
  const { body } = document;

  if (showGlobalBar === 'false') {
    $notificationBar.hide();
    body.classList.add('global-bar-hidden');
  } else {
    $notificationBar.show();
    body.classList.remove('global-bar-hidden');
  }

  $('.notification-bar--global .notification-bar__close').on(
    'click',
    function () {
      $notificationBar.hide();
      body.classList.add('global-bar-hidden');
      localStorage.setItem('showGlobalBar', 'false');
    }
  );
};

export default GlobalNotificationBar;
